import { CONTIUNITY_PLAN_BILLING_ID } from '@/constants';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import getContext from '../utilities/get-context';

const initialDownloadModalState = {
  productId: undefined,
  freeDownloadsRemaining: undefined,
  isOpen: false,
  isFree: false,
  previewType: '',
  previewImgUrl: '',
  previewImgAlt: '',
};

export default {
  state: {
    user: getContext().__MA__.user,
    openTopNavDrawer: false,
    openSignInModal: false,
    openSignUpModal: false,
    signInRedirect: undefined,
    downloadModal: initialDownloadModalState,
    plans: null,
    plansFromChargebeeLoading: true,
    isReactivationPromoVisible: false,
    currencyCode: getContext().__MA__.user?.currencyCode,
  },

  getters: {
    isLoggedIn(state) {
      return !!state.user.id;
    },

    paidUser(state, getters) {
      if (getters.isLoggedIn && state.user.gateway === 'billing_engine' && state.user.paying_user) {
        return true;
      }

      return getters.isLoggedIn && (state.user.plan !== 'free' || state.user.has_team);
    },

    userType(state, getters) {
      if (!getters.isLoggedIn) {
        return 'visitor';
      }

      if (getters.paidUser) {
        return 'paid';
      }

      return 'free';
    },

    hasContinuityPlan(state, getters) {
      return getters.isLoggedIn && state.user.plan === CONTIUNITY_PLAN_BILLING_ID;
    },
    isLocalEnv() {
      return process.env.MIX_APP_ENV === 'local';
    },
    isDevelopmentEnv() {
      return process.env.MIX_APP_ENV === 'development';
    },
    isBetaEnv() {
      if (typeof window !== 'undefined') {
        return (
          location.hostname.includes('beta.motionarray.com') ||
          location.hostname.includes('beta2.motionarray.com')
        );
      }
      return false;
    },
  },

  mutations: {
    SET_OPEN_TOP_NAV_DRAWER(state, payload) {
      state.openTopNavDrawer = payload;
    },
    SET_OPEN_SIGN_IN_MODAL(state, payload) {
      state.openSignInModal = payload;
    },
    SET_OPEN_SIGN_UP_MODAL(state, payload) {
      state.openSignUpModal = payload;
    },
    SET_SIGN_IN_REDIRECT(state, payload) {
      state.signInRedirect = payload;
    },
    SET_OPEN_DOWNLOAD_MODAL(state, payload) {
      state.downloadModal = {
        isOpen: payload.isOpen,
        ...payload,
      };
    },
    SET_CLOSE_DOWNLOAD_MODAL(state) {
      state.downloadModal = initialDownloadModalState;
    },
    SET_PLANS(state, payload) {
      state.plans = payload;
    },
    SET_PLANS_FROM_CHARGEBEE_LOADING(state, payload) {
      state.plansFromChargebeeLoading = payload;
    },
    SET_IS_REACTIVATION_PROMO_VISIBLE(state, payload) {
      state.isReactivationPromoVisible = payload;
    },
    SET_CURRENCY_CODE(state, payload) {
      state.currencyCode = payload;
    },
    SET_USER_LEAD_TYPE(state, payload) {
      state.user.leadType = payload;
    },
    SET_USER_LEAD_INFO_JOURNEY(state, payload) {
      state.user.leadInfoJourney = payload;
    },
  },

  actions: {
    setOpenTopNavDrawer({ commit }, payload) {
      if (payload) {
        commit('SET_OPEN_SIGN_IN_MODAL', false);
        commit('SET_OPEN_SIGN_UP_MODAL', false);
        commit('SET_OPEN_DOWNLOAD_MODAL', initialDownloadModalState);
      }
      commit('SET_OPEN_TOP_NAV_DRAWER', payload);
    },
    setOpenSignInModal({ commit }, { open, clickSource, buttonName, assetId }) {
      if (open) {
        eventTracker(analyticsEvents.signInPopupOpened, {
          click_source: clickSource,
          button_name: buttonName,
          asset_id: assetId,
        });
        commit('SET_OPEN_TOP_NAV_DRAWER', false);
        commit('SET_OPEN_SIGN_UP_MODAL', false);
        commit('SET_OPEN_DOWNLOAD_MODAL', initialDownloadModalState);
      } else {
        commit('SET_SIGN_IN_REDIRECT', undefined);
      }
      commit('SET_OPEN_SIGN_IN_MODAL', open);
    },
    setOpenSignUpModal({ commit }, { open, clickSource, buttonName, assetId }) {
      if (open) {
        eventTracker(analyticsEvents.signUpPopupOpened, {
          click_source: clickSource,
          button_name: buttonName,
          asset_id: assetId,
        });
        commit('SET_OPEN_TOP_NAV_DRAWER', false);
        commit('SET_OPEN_SIGN_IN_MODAL', false);
        commit('SET_OPEN_DOWNLOAD_MODAL', initialDownloadModalState);
      }
      commit('SET_OPEN_SIGN_UP_MODAL', open);
    },
    setSignInRedirect({ commit }, payload) {
      commit('SET_SIGN_IN_REDIRECT', payload);
    },
    setOpenDownloadModal({ commit }, payload) {
      if (payload) {
        commit('SET_OPEN_TOP_NAV_DRAWER', false);
        commit('SET_OPEN_SIGN_UP_MODAL', false);
        commit('SET_OPEN_SIGN_IN_MODAL', false);
      } else {
        commit('SET_SIGN_IN_REDIRECT', undefined);
      }
      commit('SET_OPEN_DOWNLOAD_MODAL', payload);
    },
    setCloseDownloadModal({ commit }) {
      commit('SET_CLOSE_DOWNLOAD_MODAL', initialDownloadModalState);
    },
    setPlans({ commit }, payload) {
      commit('SET_PLANS', payload);
    },
    setPlansFromChargebeeLoading({ commit }, payload) {
      commit('SET_PLANS_FROM_CHARGEBEE_LOADING', payload);
    },
    setIsReactivationPromoVisible({ commit }, payload) {
      commit('SET_IS_REACTIVATION_PROMO_VISIBLE', payload);
    },
    setCurrencyCode({ commit }, payload) {
      commit('SET_CURRENCY_CODE', payload);
    },
    setUserLeadType({ commit }, payload) {
      commit('SET_USER_LEAD_TYPE', payload);
    },
    setUserLeadInfoJourney({ commit }, payload) {
      commit('SET_USER_LEAD_INFO_JOURNEY', payload);
    },
  },
};
